import React, { useState, useContext, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import AuthenticationService from "../../../Api/AuthenticationService";
import { AuthContext } from "../../../Context/AuthContext";
import ClientFooter from "../ClientFooter";

const StudentLogin = () => {
    const AuthObject = new AuthenticationService();
    const { rememberCredentials, getRememberedCredentials } = useContext(AuthContext);
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        mobile_number: "",
        password: "",
        remember: false
    });

    const [showPassword, setShowPassword] = useState(false);
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    // Load remembered credentials on component mount
    useEffect(() => {
        const remembered = getRememberedCredentials();
        if (remembered.number && remembered.password) {
            setFormData(prev => ({
                ...prev,
                mobile_number: String(remembered.number),
                password: remembered.password,
                remember: true
            }));
        }
    }, [getRememberedCredentials]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : String(value)
        }));
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ""
            }));
        }
    };

    const validateForm = () => {
        const newErrors = {};
        const phoneRegex = /^\d{10,12}$/;
        const mobileNumber = String(formData.mobile_number).trim();

        if (!mobileNumber) {
            newErrors.mobile_number = "Mobile number is required";
        } else if (!phoneRegex.test(mobileNumber)) {
            newErrors.mobile_number = "Invalid mobile number format";
        }

        if (!formData.password) {
            newErrors.password = "Password is required";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            setIsLoading(true);
            try {
                if (formData.remember) {
                    rememberCredentials(formData.mobile_number, formData.password);
                }

                const response = await AuthObject.signin({
                    ...formData,
                    mobile_number: String(formData.mobile_number).trim()
                });
                const data = await response.data;

                if (response.status === 200 && data.status === "success") {

                    alert(data.data.otp);
                    navigate('/StudentOtpVerification', {
                        state: {
                            token: data.data.token,
                            mobile_number: formData.mobile_number
                        }
                    });
                } else {
                    setErrors(prev => ({
                        ...prev,
                        submit: data.message || "Login failed. Please try again."
                    }));
                }
            } catch (error) {
                setErrors(prev => ({
                    ...prev,
                    submit: "Something went wrong. Please try again."
                }));
            } finally {
                setIsLoading(false);
            }
        }
    };

    return (
        <>
            {/* Start breadcrumb Area */}
            <div className="rbt-breadcrumb-default ptb--100 ptb_md--50 ptb_sm--30 bg-gradient-1">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="breadcrumb-inner text-center">
                                <h2 className="title">Login &amp; Register</h2>
                                <ul className="page-list">
                                    <li className="rbt-breadcrumb-item">
                                        <a href="/" className="text-primary">
                                            <i className="feather-home me-1" />
                                            Home
                                        </a>
                                    </li>
                                    <li>
                                        <div className="icon-right">
                                            <i className="feather-chevron-right" />
                                        </div>
                                    </li>
                                    <li className="rbt-breadcrumb-item active">
                                        Login &amp; Register
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* End Breadcrumb Area */}
            <div className="rbt-elements-area bg-color-white rbt-section-gap">
                <div className="container">
                    <div className="row gy-5 row--30">
                        <div className="col-lg-6 offset-lg-3">
                            <div className="rbt-contact-form contact-form-style-1 max-width-auto">
                                <h3 className="title">Login</h3>
                                {errors.submit && (
                                    <div className="alert alert-danger mb-3" role="alert">
                                        {errors.submit}
                                    </div>
                                )}
                                <form className="max-width-auto" onSubmit={handleSubmit}>
                                    <div className="form-group">
                                        <input
                                            name="mobile_number"
                                            type="tel"
                                            value={formData.mobile_number}
                                            onChange={handleChange}
                                            className={errors.mobile_number ? 'is-invalid' : ''}
                                        />
                                        <label>Mobile Number *</label>
                                        <span className="focus-border" />
                                        {errors.mobile_number && <div className="invalid-feedback">{errors.mobile_number}</div>}
                                    </div>
                                    <div className="form-group">
                                        <input
                                            name="password"
                                            type={showPassword ? "text" : "password"}
                                            value={formData.password}
                                            onChange={handleChange}
                                            className={errors.password ? 'is-invalid' : ''}
                                        />
                                        <label>Password *</label>
                                        <span className="focus-border" />
                                        {errors.password && <div className="invalid-feedback">{errors.password}</div>}
                                        <span
                                            className="toggle-password cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16"
                                            onClick={() => setShowPassword(!showPassword)}
                                        >
                                            <i className={`feather-${showPassword ? 'eye-off' : 'eye'}`} />
                                        </span>
                                    </div>
                                    <div className="row mb--30">
                                        <div className="col-lg-6">
                                            <div className="rbt-checkbox">
                                                <input
                                                    type="checkbox"
                                                    id="remember"
                                                    name="remember"
                                                    checked={formData.remember}
                                                    onChange={handleChange}
                                                />
                                                <label htmlFor="remember">Remember me</label>
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="rbt-lost-password text-end">
                                                <a className="rbt-btn-link" href="#">
                                                    Lost your password?
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-submit-group">
                                        <button
                                            type="submit"
                                            className="rbt-btn btn-md btn-gradient hover-icon-reverse w-100"
                                            disabled={isLoading}
                                        >
                                            <span className="icon-reverse-wrapper">
                                                <span className="btn-text">
                                                    {isLoading ? (
                                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                    ) : null}
                                                    Log In
                                                </span>
                                                <span className="btn-icon">
                                                    <i className="feather-arrow-right" />
                                                </span>
                                                <span className="btn-icon">
                                                    <i className="feather-arrow-right" />
                                                </span>
                                            </span>
                                        </button>


                                    </div>
                                    <div className="mt-32 text-center text-sm">
                                        <p className="mb-0">
                                            Don't have an account?{" "}
                                            <Link to="/StudentRegister" className="text-primary-600 fw-semibold">
                                                Sign Up
                                            </Link>
                                        </p>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ClientFooter/>
        </>
    );
};

export default StudentLogin;
